import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GeniusQuarterHistory } from '../../shared/api/api';

export interface BaseGeniusStore {
  selectedQuarter: GeniusQuarterHistory | null;
}

export interface BaseGeniusStoreProps {
  genius: BaseGeniusStore;
}

const initialState: BaseGeniusStore = {
  selectedQuarter: null,
};

export const geniusSlice = createSlice({
  name: 'genius',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
    setSelectedQuarter(state, action: PayloadAction<GeniusQuarterHistory>) {
      state.selectedQuarter = action.payload;
    },
  },
});

export const geniusActions = geniusSlice.actions;
export const geniusReducer = geniusSlice.reducer;
